module.exports = __webpack_public_path__ + "static/media/np.5cc80132.svg";